import {
    Component,
    ContentChild,
    ContentChildren,
    HostBinding,
    HostListener,
    Input,
    QueryList,
    ViewChild,
} from '@angular/core';
import { ContainerItemComponent } from './nested/item/container-item.nested';
import { ContainerWrapOptionsComponent } from './nested/options/container-wrap.option';
import { TooltipComponent } from '../tooltip/tooltip.component';
import { Layout } from '../../baseObjects/layout';

@Component({
    selector: 'container',
    templateUrl: 'container.component.html',
    host: { 'class': 'container component' }
})
export class ContainerComponent extends Layout {

    // properties
    private _layout: string = 'fill'; // fill, wrap, tabbed
    // io
    /**
     * Specifies the layout of the container's content
     */
    get layout(): string {
        return this._layout;
    }
    @Input() set layout(value: string) {
        this._layout = value;
        switch (value) {
            case 'wrap':
                this._layoutWrap = true;
                this._layoutDock = false;
                this._layoutCanvas = false;
                break;
            case 'dock':
                this._layoutWrap = false;
                this._layoutDock = true;
                this._layoutCanvas = false;
                break;
            case 'canvas':
                this._layoutWrap = false;
                this._layoutDock = false;
                this._layoutCanvas = true;
                break;
            default:
                console.error('Invalid value for container layout - ' + value);
                break;
        }
    }

    // host bindings
    @HostBinding('class.container-layout-wrap') private _layoutWrap: boolean;
    @HostBinding('class.container-layout-dock') private _layoutDock: boolean;
    @HostBinding('class.container-layout-canvas') private _layoutCanvas: boolean;

    // host listeners
    @HostListener('mouseover') onMouseHover() {
        if (this.tooltip) {
            this.tooltipComponent.visible = true;
        }
    }

    @HostListener('mouseleave') onMouseLeave() {
        if (this.tooltip) {
            this.tooltipComponent.visible = false;
        }
    }

    // view children
    @ViewChild(TooltipComponent) tooltipComponent: TooltipComponent;

    // Content children
    @ContentChild(ContainerWrapOptionsComponent) wrapOptions: ContainerWrapOptionsComponent;
    /**
     * Specifies the items that will display when layout is in wrap mode
     */
    @ContentChildren(ContainerItemComponent) items: QueryList<ContainerItemComponent>;


    // event handlers
    onItemClick(e: ContainerItemComponent): void {
        e.onClick.emit(e);
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/components/container/container.component.ts